import React from "react";
import { Calendar, Clock, MapPin, Building2, Navigation } from "lucide-react";
import { EVENT } from "../lib/data";

const Row = ({ Icon, label, value }) => (
  <div className="flex items-start gap-3">
    <div className="bg-forest text-cream w-9 h-9 flex items-center justify-center border border-gold shrink-0">
      <Icon size={18} />
    </div>
    <div>
      <div className="eyebrow text-rust text-[0.6rem]">{label}</div>
      <div className="font-display font-semibold text-forest text-lg leading-tight">{value}</div>
    </div>
  </div>
);

export const EventDetails = () => (
  <section className="bg-cream py-20 md:py-28" data-testid="event-details-section">
    <div className="max-w-6xl mx-auto px-4 md:px-8">
      <div className="text-center mb-12">
        <p className="eyebrow text-rust mb-3">Mark Your Calendar</p>
        <h2 className="font-display font-extrabold text-forest text-4xl sm:text-5xl md:text-6xl tracking-tight">Your Ticket To Pak Fest</h2>
      </div>

      <div className="ticket grid md:grid-cols-[1.1fr_1fr] shadow-block" data-testid="ticket-stub">
        {/* Left: details */}
        <div className="p-8 md:p-10">
          <div className="flex items-center justify-between mb-6">
            <span className="numeral text-4xl text-forest">ADMIT ALL</span>
            <span className="postmark px-4 py-2 text-xs -rotate-6">Free Entry</span>
          </div>
          <div className="space-y-5">
            <Row Icon={Calendar} label="Date" value={EVENT.dateLabel} />
            <Row Icon={Clock} label="Time" value={EVENT.timeLabel} />
            <Row Icon={MapPin} label="Venue" value={`${EVENT.venue}, ${EVENT.address}`} />
            <Row Icon={Building2} label="Hosted By" value={EVENT.host} />
          </div>
          <a href={EVENT.directions} target="_blank" rel="noreferrer" className="btn-rust px-6 py-3 text-sm inline-flex items-center gap-2 mt-8" data-testid="details-directions-btn">
            <Navigation size={16} /> Get Directions
          </a>
        </div>

        {/* Right: map, separated by perforation */}
        <div className="border-t-2 md:border-t-0 md:border-l-2 border-dashed border-forest p-4">
          <div className="border-2 border-forest h-full min-h-[280px] overflow-hidden">
            <iframe
              title="Bridgewater Lakes Park Map"
              src={EVENT.mapsEmbed}
              className="w-full h-full min-h-[280px] grayscale-[0.2]"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="event-map"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
